import styled from 'styled-components'

const Header = styled.div`
  padding: 40px 20px;
`

export const Content = styled.div`
  background-color: #ffffff;
`

const Split = styled.div`
  width: 100%;
  height: 1px;
  opacity: 0.3;
  background-color: #9999bd;
`

export const CardContent = styled.div`
  padding: 40px 0;
  max-width: 750px;
  margin: auto;
`

export const CardFooter = styled.div`
  padding: 30px 0;
  max-width: 800px;
  margin: auto;
`

export const CardFooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  > * {
    margin-right: 10px;
  }

  > *:last-child {
    margin-right: 0px;
  }
`

export default {
  Header,
  Content,
  CardContent,
  Split,
  CardFooter,
  CardFooterActions
}
